import React from 'react';
import {ImageRaw} from '../../../../../components/image-raw';
import {Image} from '../../../../../components/image/image';

interface ArtistWithLightEffectProps {
    lightBeamsImage?: string;
    cloudEffectImage?: string;
    artistListImage?: string;
    concertLogoImage?: string;
    gradientClound?: string,
    lightMoonEffect?: string,
    smokeEffect?: string,
}

const ArtistWithLightEffectV2: React.FC<ArtistWithLightEffectProps> = ({
    lightBeamsImage = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/light-beams.webp',
    //cloudEffectImage = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/clound-background.png',
    artistListImage = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/v2/heart-artist-group.webp',
    concertLogoImage = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/hero-logo.webp',
    gradientClound = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/supper-banner/tinh-van-ao-anh.png',
    lightMoonEffect = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/supper-banner/sang-1x.png',
    smokeEffect = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/supper-banner/tinh-van-ao-anh.png'
}) => {
    const basePath = 'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/supper-banner';

    //w-[375px] h-[225px]
    return (
        <div>
            <style dangerouslySetInnerHTML={{
                __html: `
                    @keyframes smokeFloat1 {
                        0% { transform: translateX(0) translateY(0) scale(0.8); opacity: 0.3; }
                        50% { transform: translateX(-10px) translateY(-20px) scale(1); opacity: 0.6; }
                        100% { transform: translateX(-20px) translateY(-40px) scale(1.2); opacity: 0; }
                    }
                    @keyframes smokeFloat2 {
                        0% { transform: translateX(0) translateY(0) scale(0.9); opacity: 0.4; }
                        50% { transform: translateX(15px) translateY(-25px) scale(1.1); opacity: 0.7; }
                        100% { transform: translateX(30px) translateY(-50px) scale(1.3); opacity: 0; }
                    }
                    @keyframes smokeFloat3 {
                        0% { transform: translateX(0) translateY(0) scale(0.7); opacity: 0.2; }
                        50% { transform: translateX(-5px) translateY(-30px) scale(0.9); opacity: 0.5; }
                        100% { transform: translateX(-10px) translateY(-60px) scale(1.1); opacity: 0; }
                    }
                `
            }} />

            <div className="relative md:w-[600px] md:h-[225px] min-w-[375px] min-h-[225px]">
                <div className="absolute -top-[10%] left-[20%] h--[50%] w-[60%]">
                    <ImageRaw src={lightBeamsImage} className="object-cover mix-blend-screen" alt="" />
                </div>
                <div
                    className="absolute -left-[38%] top-[0%] w-full h-full">
                    <Image
                        src={'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/den-trai.webp'}
                        alt="Left Light"
                        fill
                        className="object-contain object-top mix-blend-lighten"
                    />
                </div>
                <div className="absolute -right-[38%] top-0 w-full h-full">
                    <Image
                        src={'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/v2/den-phai.webp'}
                        alt="Right Light"
                        fill
                        className="object-contain object-top mix-blend-lighten"
                    />
                </div>
                <div
                    className="absolute -left-[20%] top-[10%] w-[85%] h-[85%]">
                    <Image
                        src={`${basePath}/den-pha-trai.png`}
                        alt="Left Spotlight"
                        fill
                        className="object-contain object-top mix-blend-lighten"
                    />
                </div>
                <div
                    className="absolute -right-[14%] top-[18%] w-3/4 h-3/4">
                    <Image
                        src={`${basePath}/den-pha-phai.png`}
                        alt="Right Spotlight"
                        fill
                        className="object-contain object-top mix-blend-lighten"
                    />
                </div>
                <div className="absolute top-[24%] left-[52%] transform -translate-x-1/2 h-3/4 w-3/4 z-10">
                    <Image
                        src={concertLogoImage}
                        alt="Vươn Concert 2025 Logo"
                        layout="fill"
                        objectFit="contain"
                        objectPosition="top"
                        className="mix-blend-lighten"
                    />
                </div>
            </div>
            <div className="relative md:w-[600px] md:h-[360px] min-w-[375px] min-h-[225px]">
                <div
                    className="absolute top-0 left-[12%] w-full h-full">
                    <Image
                        src={lightMoonEffect}
                        alt="Lightmoon Effect"
                        fill
                        className="object-contain object-top mix-blend-screen"
                    />
                </div>
                {/* <div className="absolute top-0 left-0 h-full w-full">
              <ImageRaw src={cloudEffectImage} className="w-full h-full object-fill mix-blend-screen" alt="" />
            </div> */}
                <div
                    className="absolute
        top-[7.36%] left-[-30%]
        w-[100%] h-[100%]
        xs:top-[7.36%] xs:left-[-30%] xs:w-[100%] xs:h-[100%]
        sm:top-[7.36%] sm:left-[-30%] sm:w-[100%] sm:h-[100%]
        md:top-[7.36%] md:left-[-30%] md:w-[100%] md:h-[100%]
        lg:top-[7.36%] lg:left-[-30%] lg:w-[100%] lg:h-[100%]
        xl:top-[7.36%] xl:left-[-30%] xl:w-[100%] xl:h-[100%]">
                    <Image
                        src={'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/den-cheo-trai.webp'}
                        alt="Left Character Light"
                        fill
                        className="object-contain object-top mix-blend-screen"
                    />
                </div>
                <div
                    className="absolute
        top-[7.36%] right-[-30%]
        w-[100%] h-[100%]
        xs:top-[7.36%] xs:right-[-30%] xs:w-[100%] xs:h-[100%]
        sm:top-[7.36%] sm:right-[-30%] sm:w-[100%] sm:h-[100%]
        md:top-[7.36%] md:right-[-30%] md:w-[100%] md:h-[100%]
        lg:top-[7.36%] lg:right-[-30%] lg:w-[100%] lg:h-[100%]
        xl:top-[7.36%] xl:right-[-30%] xl:w-[100%] xl:h-[100%]">
                    <Image
                        src={'https://static.kidsplaza.vn/assets/festival2025/vuon-concert-2025/images/optimized/den-cheo-phai.webp'}
                        alt="Right Character Light"
                        fill
                        className="object-contain object-top mix-blend-screen"
                    />
                </div>
                <div
                    className="absolute top-0 left-0 w-full h-full">
                    <Image
                        src={gradientClound}
                        alt="Gradient Clound"
                        fill
                        className="object-contain object-top mix-blend-screen"
                    />

                    {/* Hiệu ứng khói layer 1 */}
                    <div
                        className="absolute top-[20%] left-[10%] w-[30%] h-[30%]"
                    >
                        <Image
                            src={smokeEffect}
                            alt="Smoke Effect 1"
                            fill
                            className="object-contain mix-blend-screen opacity-40"
                        />
                    </div>

                    {/* Hiệu ứng khói layer 2 */}
                    <div
                        className="absolute top-[15%] right-[15%] w-[25%] h-[25%]"
                    >
                        <Image
                            src={smokeEffect}
                            alt="Smoke Effect 2"
                            fill
                            className="object-contain mix-blend-screen opacity-30"
                        />
                    </div>

                    {/* Hiệu ứng khói layer 3 */}
                    <div
                        className="absolute top-[25%] left-[40%] w-[20%] h-[20%]"
                    >
                        <Image
                            src={smokeEffect}
                            alt="Smoke Effect 3"
                            fill
                            className="object-contain mix-blend-screen opacity-50"
                        />
                    </div>
                </div>
                <div className="absolute top-0 left-[12%] h-full w-[80%] sm z-10">
                    <ImageRaw
                        src={artistListImage}
                        alt="Vươn Concert 2025 Artists"
                        //layout="fill"
                        //objectFit="contain"
                        //objectPosition="top"
                        className="mix-blend-lighten"
                    />
                    {/*<ImageRaw src={artistListImage} className="w-full h-full object-cover mix-blend-screen" alt="" />*/}
                </div>
            </div>
        </div>
    );
};

export default ArtistWithLightEffectV2;
